import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/authContext";
import usePermissions from "../rbac/usePermissions";

const PrivateRoute = ({ children, requiredPermission }) => {
    const { user, isLoading } = useAuth();
    const { can } = usePermissions();

    if (isLoading) return <div>Loading...</div>;
    if (!user) return <Navigate to="/login" replace />;
    if (requiredPermission && !can(requiredPermission)) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default PrivateRoute;
